import 'rheostat/initialize';
import Rheostat, { Props } from 'rheostat';
import Handle from './components/Handle';
import Bg from './components/Bg';
import Pit from './components/Pit';
import React from 'react';

interface ISliderProps extends Props {
  customBg?: React.ElementType<any>;
  customHandle?: React.ElementType<any>;
}

/**
 * The Slider component is a wrapper for the Airbnb package "rheostat".
 * It contains only basic default styling that needs to be completed.
 * See the component `MultiSliderCalculator` for a usage example.
 *
 * _Rheostat documentation: https://github.com/airbnb/rheostat_
 */
const Slider = ({
  min,
  max,
  pitPoints,
  values,
  onChange,
  onValuesUpdated,
  snap,
  snapPoints,
  pitComponent,
  customBg,
  customHandle,
}: ISliderProps) => {
  return (
    <>
      <Rheostat
        min={min}
        max={max}
        background={customBg || Bg}
        handle={customHandle || Handle}
        pitComponent={pitComponent || Pit}
        pitPoints={pitPoints}
        values={values}
        onChange={onChange}
        onValuesUpdated={onValuesUpdated}
        snap={snap}
        snapPoints={snapPoints}
      />
      <style jsx global>{`
        /* @note: default css proposed by rheostat
        https://github.com/airbnb/rheostat
        https://unpkg.com/rheostat@3.1.0/css/rheostat.css */

        .DefaultProgressBar__vertical {
          width: 24px;
          height: 100%;
        }
        .DefaultProgressBar_progressBar {
          background-color: var(--clr-tertiary-1);
          position: absolute;
        }
        .DefaultProgressBar_progressBar__vertical {
          height: 100%;
          width: 24px;
        }
        .DefaultProgressBar_background__vertical {
          height: 100%;
          top: 0px;
          width: 15px;
        }
        .DefaultProgressBar_background__horizontal {
          height: 13px;
          top: 0px;
        }
        .rheostat {
          position: relative;
          overflow: visible;
        }
        @media (min-width: 1600px) {
          .autoAdjustVerticalPosition {
            top: 12px;
          }
        }
        .rheostat__vertical {
          height: 100%;
        }
        .handleContainer {
          height: 15px;
          top: -2px;
          left: -2px;
          bottom: 4px;
          width: 100%;
          position: absolute;
        }
      `}</style>
    </>
  );
};

export default Slider;
